<template>
  <div class="app-container feedback">
    <div class="header">
      <el-input
        placeholder="称呼"
        v-model="listQuery.name"
        :clearable="true"
        style="width: 200px;margin: 0 15px;"></el-input>
      <el-input
        placeholder="联系电话"
        v-model="listQuery.phone"
        :clearable="true"
        style="width: 200px;margin: 0 15px;"></el-input>
      <el-select
        placeholder="请选择状态"
        v-model="listQuery.handled"
        :clearable="true"
        style="margin-right: 15px;">
        <el-option label="未处理" value="0"></el-option>
        <el-option label="已处理" value="1"></el-option>
      </el-select>
      <el-button size="small" type="primary" @click="search">搜索</el-button>
    </div>
    <el-table
      :loading="listLoading"
      :data="list"
      border
      fit
      highlight-current-row
      style="margin-top: 15px;"
    >
      <el-table-column label="序号" align="center" width="95">
        <template slot-scope="scope">{{ scope.$index + 1 }}</template>
      </el-table-column>
      <el-table-column label="称呼" align="center" min-width="150">
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>
      <el-table-column label="性别" align="center" min-width="110">
        <template slot-scope="scope">
          <el-tag type="primary" v-if="scope.row.gender == 1">男</el-tag>
          <el-tag type="danger" v-else>女</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="电话" align="center" min-width="110">
        <template slot-scope="scope">{{ scope.row.phone }}</template>
      </el-table-column>
      <el-table-column label="备注" align="center" min-width="200">
        <template slot-scope="scope">{{ scope.row.remark }}</template>
      </el-table-column>
      <el-table-column label="是否已处理" align="center" min-width="95">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.handled">已处理</el-tag>
          <el-tag type="info" v-else>未处理</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" min-width="300">
        <template slot-scope="scope">
          <el-button size="small" @click="handleShowInfo(scope.row)"
            >查看详情</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="handleRead(scope.row)"
            v-if="!scope.row.handled"
            >处理</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
      <el-pagination
        :current-page="listQuery.page"
        :page-size="listQuery.limit"
        :page-sizes="[5, 10, 20, 30, 50]"
        :total="total"
        background
        layout="total,sizes,prev,pager,next,jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>

    <el-dialog v-if="showDialog" :visible.sync="showDialog" title="反馈详情">
      <el-form label-width="50px">
        <el-form-item label="称呼">
          <div style="width:500px;">{{ showContent.name }}</div>
        </el-form-item>
        <el-form-item label="性别">
          <el-tag type="primary" v-if="showContent.gender == 1">男</el-tag>
          <el-tag type="danger" v-else>女</el-tag>
        </el-form-item>
        <el-form-item label="电话">
          <div style="width:500px;">{{ showContent.phone }}</div>
        </el-form-item>
        <el-form-item label="备注">
          <div style="width:500px;">{{ showContent.remark }}</div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";
export default {
  data() {
    return {
      listLoading: false,
      total: 1,
      listQuery: {
        page: 1,
        limit: 5,
        name:'',
        phone:'',
        handle:''
      },
      list: [],
      showDialog: false,
      showContent: null
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      this.listLoading = true;
      request({
        url: "/api/backend/cooperate",
        method: "get",
        params: this.listQuery
      })
        .then(result => {
          this.list = result.data.data;
          this.total = result.data.total;
          this.listLoading = false;
        })
        .catch(err => {
          console.log(err);
        });
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    search(){
      this.listQuery.page = 1;
      this.getList();
    },
    read(row) {
      request({
        url: "/api/backend/cooperate/handled",
        method: "post",
        data: { id: row.id }
      }).then(result => {
          this.$notify.success("操作成功");
          this.getList();
        })
        .catch(err => {
          this.$notify.error("操作失败");
        })
        .finally(() => {
          this.showRefuse = false;
        });
    },
    handleRead(row) {
      this.$confirm("此操作将会处理该合作申请，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(result => {
          this.read(row)
        })
        .catch(err => {
          this.$notify.info("已取消");
        });
    },
    handleShowInfo(row) {
      this.showDialog = true;
      this.showContent = row;
    }
  }
};
</script>

<style>
.introduction {
  width: 500px;
}
.images {
  width: 500px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.imgs {
  width: 150px;
  height: 150px;
  margin-right: 20px;
  margin-bottom: 20px;
}
.imgs:nth-child(3n) {
  margin-right: 0px;
}
</style>
